<template lang="pug">
.dawn-input-tooltip
  p.dawn-input-tooltip-header {{helptipHeaderMsg}}
  p.dawn-input-tooltip-body {{helptipBody}}
</template>

<script>

export default {
  name: 'ed-input-tooltip',
  props: {
    helptipHeader: {
      type: String,
      default: 'What is this?'
    },
    helptipBody: {
      type: String,
      default: 'Please fill in this field'
    },
    errorTip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    helptipHeaderMsg: function () {
      if (this.errorTip && this.helptipHeader === 'What is this?') {
        return 'Invalid Entry'
      } else {
        return this.helptipHeader
      }
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-input-tooltip {
  z-index: 9999;
  background: linear-gradient(#fefefe, #f8f8f8);
  border: $border-width-default solid;
  border-color: $background; 
  border-radius: $border-radius;
  padding: 1em;
  position: absolute;
  left: 105%;
  top: 18%;
  width:100%;
  max-width: 400px;
  box-shadow: 0px 3px 4px 2px rgba(0, 0, 0, 0.06);

  &.error-message {
    border-color: $urgent-01; 

    &:before {
      border-color: rgba(194, 225, 245, 0);
      border-right-color: $urgent-01; 
    }
  }
}

.dawn-input-tooltip:after, .dawn-input-tooltip:before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.dawn-input-tooltip:after {
  border-color: rgba(136, 183, 213, 0);
  border-right-color: #fbfbfb;
  border-width: 14px;
  margin-top: -14px;
}
.dawn-input-tooltip:before {
  border-color: rgba(194, 225, 245, 0);
  border-right-color: $background;
  border-width: 15px;
  margin-top: -15px;
}

.dawn-input-tooltip-header {
  font-weight: $font-weight-ultra-bold;
  margin-bottom: 0;
  font-size: $font-size-base;
}

.dawn-input-tooltip-body {
  margin-bottom: 0;
  font-size: $font-size-medium;
}

</style>



// WEBPACK FOOTER //
// index.vue?1199e9b1